import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { defineComponent as _defineComponent } from 'vue';
import AzButton from '~/components/_next/atoms/AzButton.vue';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
import AzInputError from '~/components/_next/atoms/AzInputError.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'AzInput',
  props: {
    value: {
      default: ''
    },
    label: {
      default: ''
    },
    name: {
      default: ''
    },
    type: {
      default: 'text'
    },
    icon: {
      default: function _default() {}
    },
    invalid: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      default: function _default() {
        return [];
      }
    },
    hasShowPassword: {
      type: Boolean,
      default: false
    }
  },
  emits: ['input', 'click:icon'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;

    // emitters

    // refs
    var isPasswordVisible = ref(false);
    var inputType = ref(props.type);

    // computed
    var isPassword = computed(function () {
      return props.type === 'password' && props.hasShowPassword;
    });
    var nameWithoutWhitespace = computed(function () {
      return props.name.replace(/\s/g, '');
    });
    var errorMessageComputed = computed(function () {
      return Array.isArray(props.errorMessage) ? props.errorMessage : [props.errorMessage];
    });

    // methods
    function switchVisibilityPassword() {
      if (props.type !== 'password') return;
      isPasswordVisible.value = !isPasswordVisible.value;
      inputType.value = isPasswordVisible.value ? 'text' : 'password';
    }
    function handleInputEvent(ev) {
      var val = ev.target.value;
      emit('input', val);
    }
    return {
      __sfc: true,
      props: props,
      emit: emit,
      isPasswordVisible: isPasswordVisible,
      inputType: inputType,
      isPassword: isPassword,
      nameWithoutWhitespace: nameWithoutWhitespace,
      errorMessageComputed: errorMessageComputed,
      switchVisibilityPassword: switchVisibilityPassword,
      handleInputEvent: handleInputEvent,
      AzButton: AzButton,
      AzIcon: AzIcon,
      AzInputError: AzInputError
    };
  }
});